export default function(state={}, action){
  switch(action.type) {
      case 'WORKOUTS_COMPLETED':
        return {...state, workoutsCompleted:action.paylod}
      case 'WORKOUTS_COMPLETED_BY_USER':
        return {...state, workoutsCompletedByUser:action.paylod}
      case 'WORKOUTS_COMPLETED_BY_WORKOUT':
        return {...state, workoutsCompletedByWorkout:action.paylod}
      case 'PLAN_PURCHASED':
        return {...state, planPurchased:action.paylod}
      default:
          return state;
  }
}